var $6f10f3a13360a75c$exports = {};
$6f10f3a13360a75c$exports = {
  "decrease": function decrease(args) {
    return "Suma\u017Einti ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Padidinti ".concat(args.fieldLabel);
  },
  "numberField": "Numerio laukas"
};
export { $6f10f3a13360a75c$exports as default };